import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { UpdateUserInput } from '@/__generated__/graphql.ts';
import { gql } from '@/__generated__/index.ts';

const UPDATE_AVATAR = gql(`
  mutation UpdateAvatar($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      avatar {
        key
      }
    }
  }
`);

export const useUpdateAvatar = () => {
  const toast = useToast();

  const [updateAvatarMutation, result] = useMutation(UPDATE_AVATAR, {
    onCompleted() {
      toast.info({
        title: 'Avatar successfully updated',
      });
    },
    onError() {
      toast.error({
        title: 'Failed to update avatar',
        subTitle: 'Please try again',
      });
    },
  });

  const updateAvatar = (input: UpdateUserInput) => {
    updateAvatarMutation({
      variables: {
        input,
      },
    });
  };

  return [updateAvatar, result] as const;
};
